/* =========================================================
   COASTAL TOOLTIP — v4
   Fix stacking : le tooltip est TÉLÉPORTÉ dans <body> à
   l'ouverture en mode mobile, pour ne plus être piégé dans
   le contexte d'empilement d'un parent (header, section,
   swiper avec transform, etc.). Restauré à sa place d'origine
   à la fermeture, pour que Globo continue de le gérer.
   ========================================================= */
(function () {
  var IMG_CLASS      = 'coastal-tooltip-img';
  var PRICE_CLASS    = 'coastal-tooltip-price';
  var CLOSE_CLASS    = 'coastal-tooltip-close';
  var BACKDROP_CLASS = 'coastal-tooltip-backdrop';
  var MODAL_CLASS    = 'coastal-modal';
  var OPEN_CLASS     = 'is-open';
  var BODY_LOCK      = 'coastal-modal-open';

  var NO_HOVER_MQ = window.matchMedia('(hover: none), (pointer: coarse)');
  var NARROW_MQ   = window.matchMedia('(max-width: 768px)');
  function isClickMode() {
    return NO_HOVER_MQ.matches || NARROW_MQ.matches;
  }

  // ---------- utilitaires ----------
  function upscale(url, size) {
    try {
      var u = new URL(url, location.origin);
      u.pathname = u.pathname.replace(/(\.[a-zA-Z]+)$/, '_' + size + 'x$1');
      return u.toString();
    } catch (e) { return url; }
  }

  // ---------- prix multi-devises (Shopify Markets) ----------
  // Le montant Globo est exprimé dans la devise DE BASE de la boutique (CAD).
  // Shopify.currency.rate convertit toujours depuis la devise de base vers la
  // devise du marché actif, donc la conversion CAD -> devise client est gérée
  // par Shopify. Tout est lu à l'exécution, rien n'est codé en dur.
  function getShopCurrency() {
    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      return Shopify.currency.active;
    }
    return 'CAD'; // repli = devise de base de la boutique
  }

  function getShopRate() {
    var r = (window.Shopify && Shopify.currency && Shopify.currency.rate)
      ? parseFloat(Shopify.currency.rate)
      : NaN;
    return (isNaN(r) || r <= 0) ? 1 : r;
  }

  function fmtPrice(amount) {
    if (amount == null || isNaN(amount) || Number(amount) === 0) return null;

    var converted = Number(amount) * getShopRate();
    var currency  = getShopCurrency();

    // Montant formaté (séparateurs de milliers, 2 décimales), SANS symbole,
    // puis on préfixe le code devise à 3 lettres : "CAD 1,350.00".
    var num;
    try {
      num = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(converted);
    } catch (e) {
      num = converted.toFixed(2);
    }
    return '+ ' + currency + ' ' + num;
  }

  // ---------- prix du supplement ----------
  // findPrice() a ete SUPPRIME le 2026-11-03 par @liantsoa (Everfruit Digital).
  // Il cherchait le prix dans window.GPOConfigs.options en balayant les ~312 jeux
  // d'options de TOUTE la boutique et en comparant les LIBELLES (groupe + valeur),
  // premier match retenu. Deux produits partageant un libelle avec des prix
  // differents se telescopaient donc. Constate sur
  // « 100 Series Land Cruiser High Clearance Front Bumper Kit » :
  //   « 1/4" Aluminum »        affichait 708,76 au lieu de 1 008,00 (-299,24)
  //   « Welded, Powdercoated » affichait 840,00 au lieu de 1 260,00 (-420,00)
  // (valeurs du Skid Plate Kit, qui partage ces libelles). Verifie au panier :
  // 865 + 1008 = 1873 CAD, propriete de ligne _gpo_addon_products p="1008".
  // Le prix correct est deja porte par l'input de l'option COURANTE, dans
  // data-addon-price (devise de base CAD) : aucune recherche n'est necessaire.
  // Verifie identique au prix affiche par Globo sur 18 options / 18.

  // ---------- backdrop ----------
  var backdrop = null;
  function ensureBackdrop() {
    if (backdrop && document.body.contains(backdrop)) return backdrop;
    backdrop = document.createElement('div');
    backdrop.className = BACKDROP_CLASS;
    backdrop.addEventListener('click', closeAll);
    document.body.appendChild(backdrop);
    return backdrop;
  }

  // ---------- injection idempotente ----------
  function ensureCloseButton(tooltip) {
    if (tooltip.querySelector('.' + CLOSE_CLASS)) return;
    var closeWrap = document.createElement('div');
    closeWrap.className = CLOSE_CLASS;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Fermer');
    btn.innerHTML = '&times;';
    btn.addEventListener('click', function (ev) {
      ev.stopPropagation();
      ev.preventDefault();
      closeAll();
    });
    closeWrap.appendChild(btn);
    if (tooltip.firstChild) {
      tooltip.insertBefore(closeWrap, tooltip.firstChild);
    } else {
      tooltip.appendChild(closeWrap);
    }
  }

  function ensureBigImage(tooltip, item) {
    if (tooltip.querySelector('.' + IMG_CLASS)) return;
    var srcImg = item.querySelector('img.swatch-image');
    if (!srcImg || !srcImg.src) return;
    var big = document.createElement('img');
    big.className = IMG_CLASS;
    big.src = upscale(srcImg.src, 400);
    big.loading = 'lazy';
    big.alt = '';
    var closeEl = tooltip.querySelector('.' + CLOSE_CLASS);
    if (closeEl && closeEl.nextSibling) {
      tooltip.insertBefore(big, closeEl.nextSibling);
    } else if (closeEl) {
      tooltip.appendChild(big);
    } else {
      tooltip.insertBefore(big, tooltip.firstChild);
    }
  }

  function ensurePriceLine(tooltip, item) {
    var titleEl = tooltip.querySelector('.gpo-tooltip__title');
    var input   = item.querySelector('input[data-field-name], input[data-name]');
    if (!titleEl || !input) return;
    if (titleEl.querySelector('.' + PRICE_CLASS)) return;
    var priceStr = fmtPrice(parseFloat(input.getAttribute('data-addon-price')));
    if (!priceStr) return;
    var p = document.createElement('span');
    p.className = PRICE_CLASS;
    p.textContent = 'Price: ' + priceStr;
    titleEl.appendChild(p);
  }

  function enhance(tooltip) {
    if (!tooltip) return false;
    // Retrouver l'item d'origine, même si le tooltip a déjà été portalisé
    var item = tooltip._coastalItem || tooltip.closest('.gpo-ov-item');
    if (!item) return false;
    tooltip._coastalItem = item;

    var valueEl0 = tooltip.querySelector('.break-word');
    var valueText0 = valueEl0 ? (valueEl0.textContent || '').trim() : '';
    if (['none', ''].indexOf(valueText0.toLowerCase()) !== -1) {
      tooltip.style.setProperty('display', 'none', 'important');
      tooltip.setAttribute('data-coastal-hidden', '1');
      return false;
    }

    ensureCloseButton(tooltip);
    ensureBigImage(tooltip, item);
    ensurePriceLine(tooltip, item);
    watchTooltip(tooltip, item);
    return true;
  }

  var watched = new WeakSet();
  function watchTooltip(tooltip, item) {
    if (watched.has(tooltip)) return;
    watched.add(tooltip);
    var mo = new MutationObserver(function () {
      ensureCloseButton(tooltip);
      ensureBigImage(tooltip, item);
      ensurePriceLine(tooltip, item);
    });
    mo.observe(tooltip, { childList: true, subtree: false });
  }

  // ---------- portal / restore ----------
  function portalToBody(tooltip) {
    if (tooltip._coastalPortaled) return;
    tooltip._coastalOriginalParent      = tooltip.parentNode;
    tooltip._coastalOriginalNextSibling = tooltip.nextSibling;
    tooltip._coastalPortaled = true;
    tooltip.classList.add(MODAL_CLASS);
    document.body.appendChild(tooltip);
  }

  function restoreFromBody(tooltip) {
    if (!tooltip._coastalPortaled) return;
    tooltip.classList.remove(MODAL_CLASS);
    var parent = tooltip._coastalOriginalParent;
    var next   = tooltip._coastalOriginalNextSibling;
    if (parent && document.body.contains(parent)) {
      if (next && next.parentNode === parent) {
        parent.insertBefore(tooltip, next);
      } else {
        parent.appendChild(tooltip);
      }
    }
    tooltip._coastalPortaled = false;
    tooltip._coastalOriginalParent = null;
    tooltip._coastalOriginalNextSibling = null;
  }

  // ---------- open / close ----------
  function openTooltip(tooltip) {
    closeAll();

    if (isClickMode()) {
      portalToBody(tooltip);
      ensureBackdrop().classList.add(OPEN_CLASS);
      document.body.classList.add(BODY_LOCK);

      // Force un reflow pour que la transition parte de l'état fermé
      // (opacity 0) une fois la classe .coastal-modal appliquée.
      // eslint-disable-next-line no-unused-expressions
      tooltip.offsetHeight;

      requestAnimationFrame(function () {
        tooltip.classList.add(OPEN_CLASS);
      });
    } else {
      tooltip.classList.add(OPEN_CLASS);
    }
  }

  function closeAll() {
    var opened = document.querySelectorAll('.gpo-tooltip.' + OPEN_CLASS);
    opened.forEach(function (t) {
      t.classList.remove(OPEN_CLASS);
      // Attendre la fin de la transition d'opacité (~180ms), puis restaurer
      if (t._coastalPortaled) {
        setTimeout(function () {
          restoreFromBody(t);
        }, 220);
      }
    });
    if (backdrop) backdrop.classList.remove(OPEN_CLASS);
    document.body.classList.remove(BODY_LOCK);
  }

  // ---------- click délégué ----------
  document.addEventListener('click', function (ev) {
    // Le bouton close a son propre handler
    if (ev.target.closest('.' + CLOSE_CLASS + ' button')) return;

    // Click sur le backdrop → fermer (déjà géré, mais sécurité)
    if (ev.target.classList && ev.target.classList.contains(BACKDROP_CLASS)) return;

    if (!isClickMode()) return;

    var label = ev.target.closest('.gpo-swatches.image-swatches.gpo-ov-item label, .gpo-ov-item label');
    if (!label) return;

    var item = label.closest('.gpo-ov-item');
    if (!item) return;

    var tip = item.querySelector('.gpo-tooltip');
    if (!tip) return;
    if (tip.getAttribute('data-coastal-hidden') === '1') return;

    // Si le tooltip est déjà ouvert (peut arriver si l'utilisateur retap la
    // même variation), on ne fait rien de plus.
    if (tip.classList.contains(OPEN_CLASS)) return;

    // (Ré)injecter les éléments AVANT d'ouvrir, en cas de re-render de Globo
    if (!enhance(tip)) return;

    openTooltip(tip);
  }, true);

  // ---------- scan initial + observation dynamique ----------
  function scan(root) {
    (root || document).querySelectorAll('.gpo-tooltip').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches('.gpo-tooltip')) enhance(n);
        if (n.querySelectorAll) scan(n);
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });

  // Échap ferme
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') closeAll();
  });

  // Bouton back Android / navigation navigateur
  window.addEventListener('popstate', closeAll);

  // Changement de media query → fermeture propre
  function onMqChange() { closeAll(); }
  if (NO_HOVER_MQ.addEventListener) NO_HOVER_MQ.addEventListener('change', onMqChange);
  if (NARROW_MQ.addEventListener)   NARROW_MQ.addEventListener('change', onMqChange);
})();

/* =========================================================
   COASTAL — fix Globo : quand une value contient un `"`
   (ex: `1" Body Lift`), Globo tronque l'affichage à `1`
   à cause d'un défaut d'échappement HTML. On reconstruit
   l'affichage à partir du label du tooltip.
   ========================================================= */
(function () {
  // Où Globo affiche la sélection courante à côté du label de l'option.
  // On tente plusieurs noms de classes selon la version installée.
  //
  // ATTENTION : ne JAMAIS remettre ici un sélecteur large du type
  // `.gpo-label span:last-child`. Il matche `<span class="label-content">`,
  // c'est-à-dire le LIBELLÉ DE L'OPTION lui-même, tant que Globo n'a pas
  // ajouté son `<span class="addOn">` — ce qui n'arrive jamais pour
  // certaines options. Résultat : le libellé était écrasé par la valeur
  // choisie (« 3/4" Recovery Shackle (Pair) » devenait « Yes »).
  var SELECTED_VALUE_SELECTORS = [
    '.gpo-selected-values',   // la vraie classe Globo (au pluriel)
    '.gpo-selected-value',
    '.gpo-label__selected',
    '.gpo-current-value',
    '.gpo-ov-selected',
    '.gpo-label > .value',
    '.gpo-label > .addOn'
  ];

  function findSelectedTarget(element) {
    for (var i = 0; i < SELECTED_VALUE_SELECTORS.length; i++) {
      var el = element.querySelector(SELECTED_VALUE_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  // Récupère le vrai nom depuis le tooltip (non affecté par le bug d'escape)
  function getFullLabel(item) {
    var titleEl = item.querySelector('.gpo-tooltip .gpo-tooltip__title .break-word');
    if (titleEl && titleEl.textContent) return titleEl.textContent.trim();
    return null;
  }

  function updateOne(element) {
    var checked = element.querySelector(
      '.gpo-ov-item input[type="radio"]:checked, ' +
      '.gpo-ov-item input[type="checkbox"]:checked'
    );
    if (!checked) return;

    var item = checked.closest('.gpo-ov-item');
    if (!item) return;

    var fullLabel = getFullLabel(item);
    if (!fullLabel) return;

    var target = findSelectedTarget(element);
    if (!target) return;

    if (target.textContent.trim() !== fullLabel) {
      target.textContent = fullLabel;
    }

    // Globo garde .gpo-selected-values en display:none tant qu'elle n'a
    // pas la classe has-value : sans ça le correctif reste invisible.
    if (target.classList.contains('gpo-selected-values')) {
      target.classList.add('has-value');
    }
  }

  function updateAll(root) {
    (root || document).querySelectorAll('.gpo-element').forEach(updateOne);
  }

  document.addEventListener('change', function (ev) {
    var input = ev.target;
    if (!input || !input.closest) return;
    var element = input.closest('.gpo-element');
    if (element) updateOne(element);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { updateAll(); });
  } else {
    updateAll();
  }

  var mo = new MutationObserver(function () { updateAll(); });
  mo.observe(document.body, { childList: true, subtree: true });
})();
